import "./SelectButton.scss";
import React, {useEffect, useState} from 'react';
import {SelectButton} from 'primereact/selectbutton';

export function SelectButtonCustomer(props) {
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const justifyOptions = [
        {icon: 'pi pi-circle-on', value: 'OFF'},
        {icon: 'pi pi-circle-on', value: 'ON'},
    ];

    const justifyTemplate = (option) => {
        if (value === 'ON') {
            return (
                option.value === 'ON' ? 'ON' : <i className={`customer-${option.value}  ${option.icon}`}/>
            )
        } else {
            return (
                option.value === 'ON' ? <i className={`customer-${option.value}  ${option.icon}`}/> : 'OFF'
            )
        }
    }

    function _handleChange(e) {
        console.log(e)
        props.onChange();
    }

    return (
        <SelectButton value={value}
                      name="select"
                      className="select-cs"
                      options={justifyOptions}
                      onChange={(e) => _handleChange(e)}
                      itemTemplate={justifyTemplate}/>

    );
}